<template>
  <div class="custom-classes-chooser loading-mini"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <div class="choose-wrap">
      <template v-if="gradeSelect && gradeSelect.length">
        <template v-for="grade in gradeSelect">
          <slot name="group"
                :grade="grade"
                :classes-list="classesSelect[grade]"
                :remove-grade="removeGrade"
                :remove-classes="removeClasses">
            <el-popover
              :key="grade"
              title="班级列表"
              width="200"
              placement="bottom"
              trigger="hover"
              popper-class="custom-classes-chooser-popper">
              <div slot="reference"
                   :title="`${grade}级`"
                   class="group-item grade theme-light-bg-hover">
                <span class="grade-inner select-none">
                  <img src="../../../../../../../assets/images/custom/chooser/grade-group.png">
                  <span>{{grade}}级（{{classesSelect[grade].length}}）</span>
                </span>
                <i v-if="!readonly"
                   class="grade-close el-icon-close"
                   @click="removeGrade(grade)"></i>
              </div>
              <template>
                <AppScrollbar scroll-x>
                  <div class="classes-list">
                    <div v-for="classes in classesSelect[grade]"
                         :key="classes"
                         class="classes-item select-none theme-light-bg-hover">
                      <span class="classes-inner">
                        <img src="../../../../../../../assets/images/custom/chooser/classes.png">
                        <span>{{classes}}</span>
                      </span>
                      <span class="classes-close">
                        <i v-if="!readonly"
                           class="el-icon-close"
                           @click="removeClasses(classes)"></i>
                      </span>
                    </div>
                  </div>
                </AppScrollbar>
              </template>
            </el-popover>
          </slot>
        </template>
      </template>
      <div v-if="!readonly"
           class="group-item holder">
        <slot :loading="loading"
              :open="handleOpen"
              :hide="handleHide"></slot>
      </div>
    </div>
    <DataGridDialog :title="title || '选择班级'"
                    width="900px"
                    :visible.sync="visible">
      <div class="custom-classes-chooser-dialog-wrap">
        <CustomClassesChooserWrap ref="wrap"
                                :loading="loading"
                                :classes-grades="classesGrades"
                                :classes-select="classesSelect"
                                :visible="visible"
                                @select="handleSelect"
                                @hide="handleHide">
          <template v-for="slot in Object.keys($scopedSlots)"
                    :slot="slot"
                    slot-scope="scope">
            <slot :name="slot" v-bind="scope"></slot>
          </template>
        </CustomClassesChooserWrap>
      </div>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from '../../../../../../elements/grid/DataGridDialog'
import AppScrollbar from '../../../../../../elements/AppScrollbar'
import CustomClassesChooserWrap from './wrap'
export default {
  name: 'CustomClassesChooser',
  components: {
    DataGridDialog,
    AppScrollbar,
    CustomClassesChooserWrap
  },
  props: {
    title: String,
    value: Array,
    readonly: Boolean,
    dataUrl: {
      type: String,
      default: '/workspace/manager/paper/batch/queryGradeClass'
    },
    fetchParams: Object,
    fetch: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      loading: false,
      classesList: null,
      visible: false
    }
  },
  computed: {
    classesGrades () {
      let classesList = this.classesList
      let grades = {}
      if (classesList) {
        classesList.forEach(classes => {
          let grade = grades[classes.gradeName] || (grades[classes.gradeName] = {id: classes.gradeId, classesList: []})
          grade.classesList.push(classes)
        })
      }
      return grades
    },
    classesStores () {
      let classesList = this.classesList
      let stores = {}
      if (classesList) {
        classesList.forEach(classes => {
          stores[classes.name] = classes
        })
      }
      return stores
    },
    classesSelect () {
      let value = this.value
      let grades = {}
      if (value) {
        let stores = this.classesStores
        value.forEach(val => {
          let classes = stores[val]
          if (classes) {
            let grade = grades[classes.gradeName] || (grades[classes.gradeName] = [])
            grade.push(classes.name)
          }
        })
      }
      return grades
    },
    gradeSelect () {
      let gradeNames = Object.keys(this.classesSelect)
      gradeNames.sort((o1, o2) => o1 > o2 ? -1 : 1)
      return gradeNames
    }
  },
  methods: {
    handleOpen () {
      this.visible = true
    },
    handleHide () {
      this.visible = false
    },
    handleSelect (vals) {
      this.$emit('input', vals)
      this.$nextTick(() => this.handleHide())
    },
    loadClassesList () {
      this.loading = true
      this.$ajax({
        url: this.dataUrl,
        method: 'post',
        data: this.$qs.stringify(this.fetchParams)
      }).then(response => {
        if (response.data) {
          this.classesList = response.data['clazzList'] || []
        }
      }, () => {
        this.$message.error('班级数据加载失败')
      }).finally(() => {
        this.loading = false
      })
    },
    removeGrade (gradeName) {
      let value = this.value
      if (value) {
        let classesList = this.classesSelect[gradeName]
        if (classesList && classesList.length) {
          this.$emit('input', value.filter(c => !classesList.includes(c)))
        }
      }
    },
    removeClasses (classesName) {
      let value = this.value
      if (value) {
        this.$emit('input', value.filter(c => c !== classesName))
      }
    },
    addClassesNames (classesNames) {
      let wrap = this.$refs.wrap
      if (wrap) {
        let stores = this.classesStores
        let addClassesList = classesNames.map(c => stores[c]).filter(classes => !!classes)
        if (addClassesList.length) {
          wrap.addClassesList(addClassesList)
        }
      }
    },
    removeClassesNames (classesNames) {
      let wrap = this.$refs.wrap
      if (wrap) {
        let stores = this.classesStores
        let removeClassesList = classesNames.map(c => stores[c]).filter(classes => !!classes)
        if (removeClassesList.length) {
          wrap.removeClassesList(removeClassesList)
        }
      }
    }
  },
  mounted () {
    this.loadClassesList()
  }
}
</script>

<style lang="scss">
  .custom-classes-chooser {
    & > .choose-wrap {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin: -5px;
      line-height: 24px;
      .group-item {
        margin: 5px;
        &.grade {
          position: relative;
          min-width: 120px;
          height: 24px;
          line-height: 22px;
          padding-left: 5px;
          padding-right: 20px;
          background-color: #eeeff0;
          border-radius: 4px;
          box-sizing: border-box;
          .grade-inner {
            display: flex;
            align-items: center;
            position: relative;
            font-size: 12px;
            img {
              width: 12px;
              height: 12px;
              margin-right: 4px;
            }
          }
          .grade-close {
            position: absolute;
            right: 5px;
            top: 50%;
            transform: translateY(-50%);
            color: #909399;
            font-size: 14px;
            cursor: pointer;
            &:hover {
              color: #606266;
            }
          }
        }
      }
    }
  }
  .custom-classes-chooser-popper {
    min-width: 200px!important;
    padding: 0!important;
    .el-popover__title {
      font-size: 12px!important;
      padding: 12px 15px!important;
      margin-bottom: 0!important;
      border-bottom: 1px solid #ebeef5!important;
    }
    .classes-list {
      max-height: 200px;
      display: flex;
      flex-wrap: wrap;
      padding: 6px 0;
      .classes-item {
        width: 100%;
        font-size: 12px;
        line-height: 18px;
        padding: 4px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .classes-inner{
          display: flex;
          align-items: center;
          img {
            width: 12px;
            height: 12px;
            margin-right: 4px;
            color: #909399;
            cursor: pointer;
          }
        }
      }
    }
  }
  .custom-classes-chooser-dialog-wrap {
    height: 476px;
  }
</style>
